import React from 'react';
import styles from './selectPhoto.module.css';

// icons
import profileIcon from '../../../../../assets/profileIcon.svg';
import bucket from '../../../../../assets/deletePhoto.svg';
import { colors } from '../../../../../constants/colors';

const SelectPhoto = ({ photo, setPhoto, setUploadPhoto, disabled, style }) => {
  const onImageChange = (event) => {
    let reader = new FileReader();
    if (event.target.files && event.target.files[0]) {
      reader.onload = (e) => {
        setPhoto(e.target.result);
        setUploadPhoto(event.target.files[0]);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  return (
    <div className={styles.photo} style={!photo ? { border: `2px dashed ${colors.lightGrey}` } : style}>
      <label className={!photo ? styles.label : null}>
        <input type="file" accept="image/*" onChange={onImageChange} disabled={disabled} />
        <img src={photo ? photo : profileIcon} alt={'user photo'} className={photo ? styles.selectedImg : null} />
        {!photo && (
          <>
            <p>ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾ÑÐ¾ Ñ Ð¿Ðº</p>
            <span>ÐÐ·Ð¾Ð±ÑÐ°Ð¶ÐµÐ½Ð¸Ðµ Ð² ÑÐ¾ÑÐ¼Ð°ÑÐµ PNG Ð¸Ð»Ð¸ JPEG Ð½Ðµ Ð±Ð¾Ð»ÐµÐµ 200 ÐÐ±</span>
          </>
        )}
      </label>
      {photo && !disabled && (
        <button
          className={styles.delete}
          onClick={() => {
            setPhoto(undefined);
            setUploadPhoto(undefined);
          }}
        >
          <img src={bucket} alt={'Icon'} />
        </button>
      )}
    </div>
  );
};

export default SelectPhoto;
